import { observer } from "mobx-react";
import {
  initPortfolioSignaturesAction,
  prepareSignaturesState,
} from "../signatures/signaturesDomain";
import { PortfolioSignaturesTab, PortfolioType, usePortfolio } from "../portfolioDomain";
import { isPreparedPageState } from "../../signing/signDocumentDomain";
import { useDispatch, useRootStore } from "../../stores/RootStoreContext";
import { AIClient } from "../../ai/AIAssistant";
import { useEffect } from "react";
import { fromQueryString, toQueryString } from "../../utils/queryParams";
import { useAppBar } from "../../appBar/useAppBar";
import { SignaturesView } from "../signatures/signaturesComponents";

export const FollowUpSignaturesPage = observer(function PortfolioFollowUpSignaturesPage({
  signaturesTab,
  ...props
}: {
  portfolioType: PortfolioType;
  portfolioId?: string;
  signaturesTab?: PortfolioSignaturesTab;
  activeHeader?: string;
  contextCompany?: string;
}) {
  const { portfolio, onRemovePortfolio, onUpdatePortfolio, header, currentUrl } =
    usePortfolio(props);
  const location = useRootStore().location;
  const rootStore = useRootStore();
  const { messageStore, userStore } = rootStore;
  const dispatch = useDispatch();
  const aiClient = new AIClient(rootStore.http);
  useEffect(() => {
    dispatch(
      initPortfolioSignaturesAction({
        dispatch,
        portfolio,
        signaturesTab,
        store: rootStore,
        contextCompany: props.contextCompany,
        setPortfolioFollowUpCount: userStore.setPortfolioFollowUpCount,
      }),
    );
  }, [
    dispatch,
    portfolio,
    header,
    currentUrl,
    signaturesTab,
    rootStore,
    props.contextCompany,
    userStore.setPortfolioFollowUpCount,
  ]);

  const preparedState = prepareSignaturesState({
    store: rootStore,
    dispatch,
    portfolio,
    onRemovePortfolio,
    onUpdatePortfolio,
    aiClient,
    user: userStore.user,
    userPrefs: rootStore.userPrefs,
  });
  const isCompanyContextPage = props.contextCompany !== undefined;
  const queryParams = fromQueryString(location.search);

  const appBar = useAppBar({
    portfolioHeader: "follow-up",
    isPortfolioPage: !isCompanyContextPage,
    selectedPortfolioOption: portfolio,
    openPortfolioSettings:
      isPreparedPageState(preparedState, "portfolio-signatures-ready") &&
      preparedState.state.portfolio.type === "portfolio-instance"
        ? preparedState.actions.openPortfolioSettings
        : undefined,
  });
  const closeSigningCompleteDialog = () => {
    const updatedUrl = `${location.pathname}${toQueryString({
      ...queryParams,
      "signing-complete": undefined,
      "signing-complete-company": undefined,
    })}`;
    dispatch([{ type: "navigate", url: updatedUrl, replace: true }]);
  };
  const companyName: string = queryParams["signing-complete-company"] ?? "";
  const initialShowCompletedSignedDialog = queryParams["signing-complete"] === "true";
  return (
    <SignaturesView
      state={preparedState}
      portfolio={portfolio}
      alertStore={messageStore}
      showAdminLinks={userStore.hasAnyAdminRole}
      appBar={appBar}
      showSigningCompleteDialog={initialShowCompletedSignedDialog}
      closeSigningCompleteDialog={closeSigningCompleteDialog}
      companyName={companyName}
      contextCompany={props.contextCompany}
    />
  );
});
